import { L10n } from '../L10n/L10n';
import { FlowDetailInfo } from '../models/FlowInfo';
import { IDataSourceDetailInfo } from '../models/IDataSourceInfo';
import { IWorkbookDetailInfo } from '../models/IWorkbookInfo';
import { IDownloadItemInfo, INamedItemInfo } from '../models/resourceInfoParts';
import { Module } from '../Module';
import { DataSources } from '../resources/Datasources';
import { Flows } from '../resources/Flows';
import { Workbooks } from '../resources/Workbooks';
import { IContentRevision } from '../ServerApi/types/IContentRevision';
import { ToasterService, ToastType } from './ToasterService';
import { WindowLocationService } from './WindowLocationService';

export class DownloadActions {

  public static $inject = [
    '$translate',
    '$q',
    'Flows',
    'ToasterService',
    'WindowLocationService',
    'Workbooks',
    'DataSources'
  ];

  constructor(
    private $translate:ng.translate.ITranslateService,
    private $q: ng.IQService,
    private Flows: Flows,
    private toaster:ToasterService,
    private windowLocationService: WindowLocationService,
    private Workbooks:Workbooks,
    private DataSources:DataSources
  ) { }

  private download(downloadItem: IDownloadItemInfo): boolean {
    if(!downloadItem.downloadUrl) return false;

    this.windowLocationService.download(downloadItem.downloadUrl);
    return true;
  }

  public downloadFlow(flow: INamedItemInfo): ng.IPromise<FlowDetailInfo> {
    return this.Flows
      .getById(flow.id)
      .then((flow: FlowDetailInfo) => {
        const success = this.download(flow);
        if(!success) {
          this.toaster.pop({
            type: ToastType.Error,
            text: this.$translate.instant('downloadFlowError', { NAME: L10n.elideIfLong(flow.name) })
          });
        }
        return flow;
      })
      .catch((result: any) => {
        this.toaster.pop({
          type: ToastType.Error,
          text: this.$translate.instant('downloadFlowError', { NAME: L10n.elideIfLong(flow.name) })
        });
        return this.$q.reject(result);
      });
  }

  public downloadWorkbook(workbook: INamedItemInfo): ng.IPromise<IWorkbookDetailInfo> {
    return this.Workbooks
      .getById(workbook.id)
      .then((workbook: IWorkbookDetailInfo) => {
        const success = this.download(workbook);
        if(!success) {
          this.toaster.pop({
            type: ToastType.Error,
            text: this.$translate.instant('downloadWorkbookError', { NAME: L10n.elideIfLong(workbook.name) })
          });
        }
        return workbook;
      })
      .catch((result: any) => {
        this.toaster.pop({
          type: ToastType.Error,
          text: this.$translate.instant('downloadWorkbookError', { NAME: L10n.elideIfLong(workbook.name) })
        });
        return this.$q.reject(result);
      });
  }

  public downloadDatasource(datasource: INamedItemInfo): ng.IPromise<IDataSourceDetailInfo> {
    return this.DataSources
      .getById(datasource.id)
      .then((datasource: IDataSourceDetailInfo) => {
        const success = this.download(datasource);
        if(!success) {
          this.toaster.pop({
            type: ToastType.Error,
            text: this.$translate.instant('downloadDatasourceError', { NAME: L10n.elideIfLong(datasource.name) })
          });
        }
        return datasource;
      })
      .catch((result: any) => {
        this.toaster.pop({
          type: ToastType.Error,
          text: this.$translate.instant('downloadDatasourceError', { NAME: L10n.elideIfLong(datasource.name) })
        });
        return this.$q.reject(result);
      });
  }

  public downloadContentRevision(revision: IContentRevision): ng.IPromise<any> {
    const success = this.download(revision);
    if(!success) {
      this.toaster.pop({ type: ToastType.Error, text: this.$translate.instant('downloadRevisionError') });
    }
    return this.$q.when();
  }

}

Module.instance().service('DownloadActions', DownloadActions);
